import React, { useState } from 'react'
import { func } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { userType } from 'models/propTypes'

import ChangePasswordContainer from 'containers/accountAccess/ChangePasswordContainer'

require('./Profile.scss')

const Profile = ({ user, resetChangePassword, logout, deleteUser }) => {
    const { t } = useTranslation()
    const [changingPassword, setChangingPassword] = useState(false)
    const onCloseChangePassword = () => {
        if (changingPassword) {
            resetChangePassword()
        }
        setChangingPassword(!changingPassword)
    }

    return (
        <div className="Profile">
            <div className="intro">
                <h1>{user.firstName ? t('profile.greeting', { name: user.firstName }) : user.email}</h1>
                <span>
                    {t('profile.not you?')} <button onClick={logout}>{t('header.logout')}</button>
                </span>
            </div>
            <ul className="tabs">
                <li>{t('profile.my account')}</li>
            </ul>
            <div className="profileContent">
                <section>
                    <h4>{t('profile.personal information')}</h4>
                    <p>
                        {user.firstName} {user.lastName}
                    </p>
                </section>
                <section>
                    <h4>{t('profile.contact')}</h4>
                    <p>{user.email}</p>
                </section>
                {user.canChangePassword ? (
                    <section>
                        <button className="edit" onClick={onCloseChangePassword}>
                            {changingPassword ? t('profile.close') : t('profile.edit')}
                        </button>
                        <h4>{t('profile.password')}</h4>
                        {changingPassword ? (
                            <ChangePasswordContainer onClose={onCloseChangePassword} />
                        ) : (
                            // eslint-disable-next-line i18next/no-literal-string
                            <p>&bull;&bull;&bull;&bull;&bull;</p>
                        )}
                    </section>
                ) : null}
                <button className="deleteUser" onClick={deleteUser} />
            </div>
        </div>
    )
}

Profile.propTypes = {
    user: userType.isRequired,
    resetChangePassword: func.isRequired,
    logout: func.isRequired,
    deleteUser: func.isRequired,
}

export default Profile
